'use client';

var EventHelper = /** @class */ (function () {
    function EventHelper() {
        this.on = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.addEventListener(eventName, handler);
            }
        };
        this.off = function (eventName, handler) {
            if (typeof window !== 'undefined') {
                window.removeEventListener(eventName, handler);
            }
        };
        this.emit = function (eventName, pamarater) {
            if (typeof window !== 'undefined') {
                var event_1 = new CustomEvent(eventName, pamarater);
                window.dispatchEvent(event_1);
            }
        };
    }
    return EventHelper;
}());
var eventHelper = new EventHelper();
var getSliderItems = function (language) {
    var link = 'vi/infographic-tips/tim-viec-truc-tuyen-an-toan';
    var sliderItems = [
        {
            image: 'job-detail/cheating-5.png',
            link: link,
            titleVi: 'Lừa đảo thu phí',
            descriptionVi: 'Đưa ra lời mời làm việc dễ dàng bất thường, đãi ngộ cao, kèm theo yêu cầu nộp các loại phí.',
            titleEn: 'Fee Scam',
            descriptionEn: 'Give an unusual job offer with high benefit and paying fee requirement.'
        },
        {
            image: 'job-detail/cheating-6.png',
            link: link,
            titleVi: 'Đánh cắp thông tin ngân hàng',
            descriptionVi: 'Yêu cầu cung cấp thông tin tài khoản ngân hàng, mật khẩu, thẻ thanh toán, mã OTP.',
            titleEn: 'Banking information stealing',
            descriptionEn: 'Request to provide banking information, password, credit card, OTP code.'
        },
        {
            image: 'job-detail/cheating-7.png',
            link: link,
            titleVi: 'Đánh cắp danh tính',
            descriptionVi: 'Yêu cầu cung cấp bản Scan, chụp Giấy tờ tuỳ thân, mật khẩu Email để sử dụng trái phép danh tính của ứng viên.',
            titleEn: 'Personal information stealing ',
            descriptionEn: 'Request to provide Scan, photo of ID documents, Email password for illegally purpose.'
        },
        {
            image: 'job-detail/cheating-8.png',
            link: link,
            titleVi: 'Buôn bán lao động',
            descriptionVi: 'Đưa ra lời mời làm việc dễ dàng bất thường, mức đãi ngộ cao, yêu cầu không rõ ràng, địa điểm làm việc ở nước ngoài.',
            titleEn: 'Labor sale scam',
            descriptionEn: 'Giving an unusual job offers, high compensation, but unclear requirements, overseas location.'
        },
        {
            image: 'job-detail/cheating-9.png',
            link: link,
            titleVi: 'Giả dạng công ty lớn, uy tín',
            descriptionVi: 'Đăng tin mạo danh các tập đoàn quy mô lớn, gửi thông tin trực tiếp qua tin nhắn riêng cho người tìm việc.',
            titleEn: 'Famous companies scam',
            descriptionEn: 'Fake job posting from famous company, sending private message to candidates.'
        },
        {
            image: 'job-detail/cheating-10.png',
            link: link,
            titleVi: 'Tham gia thực hiện nhiệm vụ',
            descriptionVi: 'Yêu cầu ứng viên tham gia khảo sát/thử việc hoặc làm nhiệm vụ bằng cách cài đặt các ứng dụng điện thoại.',
            titleEn: 'Mission scam',
            descriptionEn: 'Ask candidates to take part in a survey/trial or task by installing mobile apps.'
        }
    ];
    return sliderItems;
};

export { eventHelper, getSliderItems };
//# sourceMappingURL=helper.js.map
